import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { viewStateSelector, dataStateSelector } from "../redux/selectors";
import {
  toggle,
  updateParams,
  readingNotification as readingNotificationAction,
  toggleBulkMode as toggleBulkModeAction,
  toggleBulkModeClearNotification as toggleBulkModeClearNotificationAction,
  removeAllShouldClearNotification,
  readingNotificationBulk,
} from "../redux/actions";
import {
  Badge,
  Drawer,
  IconButton,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import { Notifications, NotificationsActive } from "@material-ui/icons";
import { NotificationList } from "./NotificationList";
import { NotificationListEmpty } from "./NotificationListEmpty";
import { NotificationListBulkMenu } from "./NotificationListBulkMenu";
import { NotificationListHeader } from "./NotificationListHeader";
import { QueryParams } from "@ofqual/portal-core/core/types";

const useStyles = makeStyles((theme) => ({
  headerAndList: {
    padding: "0 0px 0px",
    width: "650px",
    // overflow: "hidden",
    height: "100%", // force bulk menu to the bottom
    position: "relative",
  },
}));

export interface ComponentProps {
  pushHistoryFunc?: (url: string) => void;
}

export const Component: React.FC<ComponentProps> = ({ pushHistoryFunc }) => {
  const dispatch = useDispatch();
  const viewState = useSelector(viewStateSelector);
  const dataState = useSelector(dataStateSelector);
  const classes = useStyles();
  const { isOpen, isBulkMode } = viewState;

  const { hasData, response } = dataState;

  const thisPageItemIds = dataState.response.data.map((item) => item.id);

  const areAllCheckboxesChecked =
    isBulkMode &&
    thisPageItemIds.every((id) => viewState.notificationsToClear.includes(id));

  const readingNotification = (id: string) =>
    dispatch(readingNotificationAction(id));

  const toggleBulkMode = (isBulkMode: boolean) =>
    dispatch(toggleBulkModeAction(isBulkMode));

  const toggleBulkModeClearNotification = (id: string, shouldClear: boolean) =>
    dispatch(toggleBulkModeClearNotificationAction([id], shouldClear));

  const toggleAllBulkModeClearNotification = (shouldClear: boolean) =>
    dispatch(
      toggleBulkModeClearNotificationAction(thisPageItemIds, shouldClear)
    );

  const removeAll = () => dispatch(removeAllShouldClearNotification());

  const clearSelected = () => dispatch(readingNotificationBulk());

  const navigate = (nextParams: QueryParams) =>
    dispatch(updateParams(nextParams));

  const toggleOpen = (isOpen: boolean) => dispatch(toggle(isOpen));

  return (
    <>
      <Tooltip title="View notifications">
        <IconButton
          aria-label={`show new notifications`}
          color="inherit"
          onClick={() => {
            toggleOpen(!isOpen);
          }}
          data-test="notification-icon"
        >
          <Badge
            // IMPORTANT!!!!: notificationBadge class only exists to fudge this new notifications
            //  component into the old portal.  Once old portal is decommissioned it can be removed.
            className="notificationBadge"
            // ^ IMPORTANT!!!
            badgeContent={
              hasData && response.count ? String(response.count) : ""
            }
            color="primary"
          >
            {hasData && response.count ? (
              <NotificationsActive />
            ) : (
              <Notifications />
            )}
          </Badge>
        </IconButton>
      </Tooltip>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={() => {
          toggleOpen(false);
        }}
      >
        <div className={classes.headerAndList}>
          <NotificationListHeader
            isBulkMode={isBulkMode}
            toggleBulkMode={toggleBulkMode}
            dataState={dataState}
            haveItems={!!thisPageItemIds.length}
            navigate={navigate}
          />

          {hasData && (
            <NotificationList
              dataState={dataState}
              viewState={viewState}
              readingNotification={readingNotification}
              toggleBulkModeClearNotification={toggleBulkModeClearNotification}
              pushHistoryFunc={pushHistoryFunc}
            />
          )}

          <div>
            {hasData && !response.count ? <NotificationListEmpty /> : null}
          </div>
          {isBulkMode ? (
          <NotificationListBulkMenu
            areAllCheckboxesChecked={areAllCheckboxesChecked}
            countNotificationSelected={viewState.notificationsToClear.length}
            toggleAllBulkModeClearNotification={
              toggleAllBulkModeClearNotification
            }
            removeAll={removeAll}
            clearSelected={clearSelected}
          />
        ) : null}
        </div>
       
      </Drawer>
    </>
  );
};
